const tabPalette = (tokens) => {
    return {
        padding: tokens.tabPadding,
        spaceBetween: tokens.tabSpaceBetween,
        font: {
            fontFamily: tokens.tabFontFamily,
            fontSize: tokens.tabFontSize,
            fontWeight: tokens.tabFontWeight
        },
        background: {
            default: tokens.tabColorBgDefaultDefault,
            hover: tokens.tabColorBgDefaultHover,
            focus: tokens.tabColorBgDefaultFocus,
            selected: {
                default: tokens.tabColorBgSelectedDefault,
                hover: tokens.tabColorBgSelectedHover,
                focus: tokens.tabColorBgSelectedFocus
            }
        },
        border: {
            default: tokens.tabColorBorderDefaultDefault,
            hover: tokens.tabColorBorderDefaultHover,
            focus: tokens.tabColorBorderDefaultFocus,
            selected: {
                default: tokens.tabColorBorderSelectedDefault,
                hover: tokens.tabColorBorderSelectedHover,
                focus: tokens.tabColorBorderSelectedFocus
            },
            radius: tokens.tabRadius,
            width: {
                horizontal: {
                    bottom: tokens.tabBorderWidthHorizontalDefaultBottom,
                    top: tokens.tabBorderWidthHorizontalDefaultTop,
                    left: tokens.tabBorderWidthHorizontalDefaultLeft,
                    right: tokens.tabBorderWidthHorizontalDefaultRight,
                    selected: {
                        bottom: tokens.tabBorderWidthHorizontalSelectedBottom,
                        top: tokens.tabBorderWidthHorizontalSelectedTop,
                        left: tokens.tabBorderWidthHorizontalSelectedLeft,
                        right: tokens.tabBorderWidthHorizontalSelectedRight
                    }
                },
                vertical: {
                    bottom: tokens.tabBorderWidthVerticalDefaultBottom,
                    top: tokens.tabBorderWidthVerticalDefaultTop,
                    left: tokens.tabBorderWidthVerticalDefaultLeft,
                    right: tokens.tabBorderWidthVerticalDefaultRight,
                    selected: {
                        bottom: tokens.tabBorderWidthVerticalSelectedBottom,
                        top: tokens.tabBorderWidthVerticalSelectedTop,
                        left: tokens.tabBorderWidthVerticalSelectedLeft,
                        right: tokens.tabBorderWidthVerticalSelectedRight
                    }
                }
            }
        },
        text: {
            default: tokens.tabColorTextDefault,
            selected: tokens.tabColorTextSelected
        }
    };
};
export default tabPalette;
//# sourceMappingURL=tab.js.map